module.exports = __webpack_public_path__ + "media/images/icons/house2x-9a89842b1f0d50100d01dc6c88db0e88.png";